import React from "react";
import DatePicker from "react-datepicker";

type DatePickerFieldProps = {
  value: Date | null;
  onChange: (date: Date | null) => void;
  placeholder?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
  disabled?: boolean;
  minDate?: Date;
  maxDate?: Date;
};

const sizeClasses: Record<NonNullable<DatePickerFieldProps["size"]>, string> = {
  sm: "h-9 text-sm px-3 pr-10",
  md: "h-10 text-md px-4 pr-10",
  lg: "h-[50px] text-lg px-4 pr-10",
};

export default function DatePickerField({
  value,
  onChange,
  placeholder = "Select date",
  size = "md",
  className = "",
  disabled = false,
  minDate,
  maxDate,
}: DatePickerFieldProps) {
  return (
    <div className="relative w-full">
      <DatePicker
        selected={value}
        onChange={onChange}
        dateFormat="M/d/yyyy"
        placeholderText={placeholder}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        wrapperClassName="w-full"
        popperClassName="ls-datepicker-popper"
        calendarClassName="ls-datepicker-calendar"
        className={[
          "ls-datepicker-input w-full rounded-[8px] border border-light-grey bg-white text-dark-black outline-none transition-colors duration-200",
          "focus:border-brand-blue focus:ring-1 focus:ring-brand-blue",
          sizeClasses[size],
          className,
        ]
          .filter(Boolean)
          .join(" ")}
      />
      <img
        src="/icons/date_picker.svg"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2"
      />
    </div>
  );
}
